module.exports = __webpack_public_path__ + "d3becf4c6f7a9aa0976c6cc26ce83015.svg";